import { has } from 'lodash-es'
import { UpgradeRegistryItem } from '../upgrader.types'
/**
 * component 对应组件类型
 * form 从某个版本开始升级
 * to 升级到的版本
 * upgrade 升级方法，具体的值
 *  {
      from: 1,
      to: 2,
      upgrade(schema) {
        // 添加 autoFitHeight 属性，默认为 false
        // if (!('autoFitHeight' in schema.prop)) {
        //   schema.prop.autoFitHeight = false
        // }
        return schema
      }
    }
 */
export const BigScreenCustomMapUpgrades: UpgradeRegistryItem = {
  component: 'BigScreenCustomMap',
  upgrades: [
    {
      from: 3,
      to: 4,
      upgrade(schema) {
        schema.prop.customSeries.forEach((series: any) => {
          if (series.type === 'map' && !has(series, 'tooltip')) {
            series['tooltip'] = {
              formatter: ''
            }
          }
        })
        return schema
      }
    },
    {
      from: 4,
      to: 5,
      upgrade(schema) {
        schema.prop.customSeries.forEach((series: any) => {
          if (series.type === 'stud' && !has(series, 'geoIndex')) {
            series['geoIndex'] = 0
          }
        })
        return schema
      }
    }
  ]
}
